/** 能源管理 **/

import Layout from "@/views/layout/Layout";

const energyManRouter = {
  path: "/energyMan",
  component: Layout,
  name: "energyMan",
  meta: {
    title: "能源管理",
    icon: "nygl",
    roles: ["jichuyunying"]
  },
  children: [
    {
      path: "energyMonitor",
      component: () => import("@/views/energyMan/energyMonitor"),
      name: "能源看板",
      meta: {
        title: "能源看板",
        roles: ["jichuyunying"]
      }
    },
    {
      path: "areaQuery",
      component: () => import("@/views/energyMan/areaQuery"),
      name: "区域用能查询",
      meta: {
        title: "区域用能查询",
        roles: ["jichuyunying"]
      }
    },
    {
      path: "equipQuery",
      component: () => import("@/views/energyMan/equipQuery"),
      name: "设备用能查询",
      meta: {
        title: "设备用能查询",
        roles: ["jichuyunying"]
      }
    },
    {
      path: "energyStructure",
      component: () => import("@/views/energyMan/energyStructure"),
      name: "能耗结构分析",
      meta: {
        title: "能耗结构分析",
        roles: ["jichuyunying"]
      }
    },
    {
      path: "energyRank",
      component: () => import("@/views/energyMan/energyRank"),
      name: "能耗排名分析",
      meta: {
        title: "能耗排名分析",
        roles: ["jichuyunying"]
      }
    },
    {
      path: "energyTrend",
      component: () => import("@/views/energyMan/energyTrend"),
      name: "能耗趋势分析",
      meta: {
        title: "能耗趋势分析",
        roles: ["jichuyunying"]
      }
    },
    {
      path: "energyExceptionMan",
      component: () => import("@/views/energyMan/energyExceptionMan"),
      name: "用能异常管理",
      meta: {
        title: "用能异常管理",
        roles: ["jichuyunying"]
      }
    }
  ]
};

export default energyManRouter;
